"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4821],{

/***/ 74821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zb": function() { return /* reexport */ Card_Card; },
  "q4": function() { return /* reexport */ CardSkeleton; }
});

// UNUSED EXPORTS: CardAsset, CardContentA, CardContentB, CardContentC, CardContentE, CardContentF, CardContentG, CardContentH

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/Card/@editor/index.ts



var useEditorHandlers = function(name) {
    var configuration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], style = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_card_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.background.paper
            },
            {
                name: "theme_component_card_border_radius",
                label: "Border radius",
                type: "number",
                endAdornment: "px",
                default: theme.shape.borderRadius
            },
            {
                name: "theme_component_card_box_shadow",
                label: "Box shadow",
                type: "text",
                default: theme.shadows[3]
            },
            {
                name: "component_card_title_text",
                label: "Button Text",
                type: "text",
                default: ""
            },
            {
                type: "divider"
            },
            {
                name: "theme_component_card_content_border",
                label: "Border",
                placeholder: "1px solid #fff",
                type: "text",
                default: "none"
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(style)),
        configuration: [
            {
                name: "component_card_width",
                label: "Width",
                type: "number",
                endAdornment: "px",
                default: 512,
                helperText: "Specify the width of your card. The card remains responsive, but based on the width and height; an aspect ratio will be set."
            },
            {
                name: "component_card_height",
                label: "Height",
                type: "number",
                default: 288,
                endAdornment: "px"
            },
            {
                name: "component_game_carousel_card_type",
                label: "Card Type",
                type: "select",
                default: "simple",
                options: [
                    "default",
                    "simple",
                    "extensive",
                    "partial",
                    "big"
                ]
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(configuration))
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActionArea/CardActionArea.js + 1 modules
var CardActionArea = __webpack_require__(9974);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var components_Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./src/components/ImageLoaderWrapper/index.ts + 2 modules
var ImageLoaderWrapper = __webpack_require__(95073);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(83965);
;// CONCATENATED MODULE: ./src/components/Card/CardAsset.tsx








var CardMediaStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(_param) /*#__PURE__*/ {
    var innerFlexSize = _param.innerFlexSize, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "innerFlexSize",
        "sx"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardMedia/* default */.Z, (0,src_object_spread/* default */.Z)({}, other));
}, {
    target: "efn99i20"
})(function(param) {
    var theme = param.theme, _innerFlexSize = param.innerFlexSize, innerFlexSize = _innerFlexSize === void 0 ? "auto" : _innerFlexSize, sx = param.sx;
    var _obj;
    return (0,src_object_spread/* default */.Z)((_obj = {
        width: "100%",
        height: "100%",
        backgroundColor: "none",
        pointerEvents: "none",
        marginBottom: "auto",
        "& span:first-of-type": {
            display: "block !important"
        },
        flex: innerFlexSize
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        flex: "auto"
    }), (0,src_define_property/* default */.Z)(_obj, "& span", {
        height: "100% !important"
    }), _obj), sx);
});
var CardAsset = function(props) {
    var width = props.width, height = props.height, _className = props.className, className = _className === void 0 ? "card-asset" : _className, innerFlexSize = props.innerFlexSize, assetsx = props.assetsx, other = (0,_object_without_properties/* default */.Z)(props, [
        "width",
        "height",
        "className",
        "innerFlexSize",
        "assetsx"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardMediaStyled, {
        className: "card-asset card-asset-test",
        innerFlexSize: innerFlexSize,
        sx: assetsx,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "card-img",
            style: {
                display: "block",
                position: "relative",
                height: "100%"
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLoaderWrapper/* ImageLoaderWrapper */.T, (0,src_object_spread/* default */.Z)({
                width: width,
                height: height
            }, other))
        })
    });
};

// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
;// CONCATENATED MODULE: ./src/utils/get-text.ts
var getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentA.tsx








var CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1e8ztf40"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        "&:last-child": {
            paddingBottom: theme.spacing(1)
        }
    };
});
var CardContentA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled. Had trouble extending our CardContentAProps...
var CardContentA = function(props) {
    var title = props.title, limit = props.limit, className = props.className;
    var captionRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentStyled, {
            className: className,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentA_Typography, {
                ref: captionRef,
                sx: {
                    width: "100%",
                    display: "inline-block"
                },
                variant: "caption",
                component: "span",
                noWrap: true,
                children: getText(title, limit || 35)
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentB.tsx









var CardContentB_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1k8u2y20"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column-reverse",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%",
        borderTop: "none",
        pointerEvents: "none",
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        width: "100%",
        "&:last-child": {
            paddingBottom: theme.spacing(2)
        }
    }, theme.breakpoints.up("md"), {
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2)
    });
});
var CardContentB_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled. Had trouble extending our CardContentBProps...
var CardContentB = function(props) {
    var title = props.title, limit = props.limit, className = props.className;
    var captionRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentB_CardContentStyled, {
            className: className,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentB_Typography, {
                ref: captionRef,
                sx: {
                    width: "100%",
                    display: "inline-block",
                    fontSize: "1.3rem",
                    px: {
                        xs: 0.5,
                        md: 1
                    },
                    wordBreak: "break-word",
                    overflowWrap: "break-word"
                },
                variant: "caption",
                color: "textPrimary",
                component: "p",
                noWrap: true,
                children: getText(title, limit || 35)
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
;// CONCATENATED MODULE: ./src/components/Card/CardContentC.tsx












var CardContentC_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentC_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentC_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "eclqiin0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        display: "none"
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column-reverse",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%",
        textAlign: "center",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentC_Typography, {
    target: "eclqiin1"
})(function(param) {
    var theme = param.theme;
    return {
        marginTop: theme.spacing(2),
        height: "80px"
    };
});
var ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentC_Button, {
    target: "eclqiin2"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        width: "auto",
        height: "auto",
        margin: 0,
        marginTop: theme.spacing(-3.5),
        padding: theme.spacing(0.5, 2),
        borderRadius: "100px",
        border: "1px solid #ebebeb",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main
    };
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CardContentC = function(props) {
    var description = props.description, limit = props.limit, className = props.className;
    var t = (0,esm/* useTranslation */.$G)("card_content_c").t;
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentC_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary",
                children: description && getText(description, limit || 85)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonStyled, {
                ref: buttonRef,
                variant: "contained",
                disableElevation: true,
                disableRipple: true,
                disableFocusRipple: true,
                size: "small",
                children: componentOptions.component_card_title_text || t("play_now", "Play")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentE.tsx





var CardCarousel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kzlu9v0"
})(function() {
    return {
        position: "absolute",
        top: 0,
        left: 0,
        transition: "transform 0.2s cubic-bezier(0.5, 0, 0.1, 1)",
        cursor: "pointer"
    };
});
var CarouselCardContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kzlu9v1"
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0.5),
        height: "100%"
    };
});
var CarouselCardCover = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("img", {
    target: "e1kzlu9v2"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.palette.grey["900"],
        width: "100%",
        height: "100%",
        borderRadius: theme.spacing(1),
        boxSizing: "border-box",
        border: "1px solid transparent",
        " -webkit-box-shadow": "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12),\n    0 1px 3px 0 rgba(0, 0, 0, 0.2)",
        boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);",
        "-moz-box-shadow": "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2)"
    };
});
var CardContentE = function(props) {
    var game = props.game, width = props.width, height = props.height, pointX = props.pointX, pointY = props.pointY;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var assetUrl = appContext.useConfig().assetUrl;
    var scaleTimeout;
    var onMouseEnter = function(e) {
        var _target = e.target;
        while(_target.classList[0] !== "card-carousel"){
            // @ts-ignore
            _target = _target.parentNode;
        }
        var _cover = _target.querySelector(".carousel-card-cover");
        // @ts-ignore
        _cover.style.border = "2px solid aqua";
        if (_target.style.width !== "364px") {
            scaleTimeout = setTimeout(function() {
                // @ts-ignore
                _target.style.zIndex = 1;
                _target.style.transform = _target.style.transform + " scale(1.2)";
            }, 400);
        }
    };
    var onMouseLeave = function(e) {
        clearTimeout(scaleTimeout);
        var _target = e.target;
        while(_target.classList[0] !== "card-carousel"){
            // @ts-ignore
            _target = _target.parentNode;
        }
        _target.style.transform = _target.style.transform.replace(" scale(1.2)", "");
        // @ts-ignore
        _target.style.zIndex = null;
        var _cover = _target.querySelector(".carousel-card-cover");
        // @ts-ignore
        _cover.style.border = null;
        // @ts-ignore
        _cover.style.borderRadius = null;
    };
    if (!game) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardCarousel, {
        className: "card-carousel",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: {
            width: "".concat(width, "px"),
            height: "".concat(height, "px"),
            transform: "translateX(".concat(pointX, "px) translateY(").concat(pointY, "px)")
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCardContent, {
            className: "carousel-card-content",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Link/* Link */.r, {
                href: {
                    pathname: "/game/[slug]",
                    query: {
                        slug: game.slug
                    }
                },
                title: (game === null || game === void 0 ? void 0 : game.name) || undefined,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCardCover, {
                    className: "carousel-card-cover",
                    src: "".concat(assetUrl).concat(game.images.cover16x9 || game.images.cover, "/")
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentF.tsx










var CardContentF_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentF_Button = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function(props, ref) {
    return useHighlightHandlers(MuiButton, _object_spread({
        forwardedRef: ref
    }, props));
})));
var CardContentF_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1vppp510"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        // paddingBottom: `${theme.spacing(3)} !important`,
        width: "100%",
        justifyContent: "space-between"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        padding: theme.spacing(3, 4),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        display: "flex",
        flexDirection: "column",
        height: "100%"
    }), _obj;
});
var CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentF_Typography, {
    target: "e1vppp511"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        display: "inline-block",
        paddingBottom: theme.spacing(1),
        fontSize: theme.spacing(2.5),
        fontWeight: "bold",
        color: theme.theme_component_navigation_bar_background_color,
        whiteSpace: "inherit"
    }, theme.breakpoints.down("sm"), {
        fontSize: theme.spacing(2.25),
        lineHeight: theme.spacing(2.75)
    });
});
var CardContentF_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentF_Typography, {
    target: "e1vppp512"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: "auto",
        fontSize: theme.spacing(2),
        color: "#6E6E6E",
        lineHeight: "28px"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        minHeight: "80px",
        fontSize: theme.spacing(1.75),
        lineHeight: theme.spacing(2.5)
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        height: "80px"
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), (0,src_define_property/* default */.Z)({}, theme.breakpoints.down("lg"), {
        height: "70px",
        lineHeight: "20px"
    })), _obj;
});
var CardContentF_ButtonStyled = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(CardContentF_Button, {
    target: "e1vppp513"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        width: "104px",
        height: "40px",
        margin: 0,
        marginTop: theme.spacing(3),
        padding: theme.spacing(0),
        borderRadius: "8px",
        border: "1px solid #ebebeb",
        fontSize: "16px",
        fontWeight: "bold",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main,
        textTransform: "none"
    };
})));
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CardContentF = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className;
    var body2Ref = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentF_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle, {
                variant: "caption",
                component: "span",
                noWrap: true,
                children: getText(title || "", limit || 35)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentF_Description, {
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary",
                children: description && getText(description, limit || 85)
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./src/components/Card/CardContentBanner.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 16px;\n      text-transform: none;\n      white-space: normal;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 7;\n      display: -webkit-box;\n      color: #6e6e6e;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var CardContentBanner_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentBanner_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e9ri2380"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "flex-start",
        textAlign: "left",
        width: "100%",
        height: "100%",
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(0),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(0),
        "&:last-child": {
            paddingBottom: theme.spacing(1)
        }
    };
});
var CardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentBanner_Button, {
    target: "e9ri2381"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        padding: theme.spacing(0, 5),
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "30%"
    }, theme.breakpoints.down("md"), {
        alignItems: "normal",
        width: "auto"
    });
});
var CardContentBanner_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentBanner_Button, {
    target: "e9ri2382"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "inline-block",
        width: "104px",
        height: "40px",
        margin: 0,
        padding: theme.spacing(0),
        borderRadius: "8px",
        border: "1px solid #B1B1B1",
        marginLeft: theme.spacing(0),
        marginTop: theme.spacing(1),
        fontSize: "16px",
        fontWeight: "bold",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main,
        textTransform: "none"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        marginBottom: theme.spacing(3)
    }), (0,src_define_property/* default */.Z)(_obj, "&:hover", {
        backgroundColor: "#cc0100"
    }), _obj;
});
var CardContentBanner_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var DescriptionStyled = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)((0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(_templateObject()), (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentBanner = function(props) {
    var title = props.title, description = props.description, limit = props.limit, className = props.className;
    var captionRef = react.useRef(null);
    var buttonRef = react.useRef(null);
    var t = (0,esm/* useTranslation */.$G)("card_content_banner").t;
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_CardContentStyled, {
                    className: className,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_Typography, {
                        ref: captionRef,
                        sx: {
                            width: "100%",
                            display: "inline-block",
                            fontWeight: 700,
                            fontSize: "20px",
                            color: "#0C0C0C"
                        },
                        variant: "caption",
                        component: "span",
                        noWrap: true,
                        children: getText(title, limit || 35)
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_CardContentStyled, {
                    className: className,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionStyled, {
                        ref: captionRef,
                        variant: "caption",
                        color: "textPrimary",
                        component: "span",
                        noWrap: true,
                        children: description
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_ButtonStyled, {
                    ref: buttonRef,
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    children: componentOptions.component_card_title_text || t("play_now", "Play")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentFHardcoded.tsx











var CardContentFHardcoded_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentFHardcoded_Button = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function(props, ref) {
    return useHighlightHandlers(MuiButton, _object_spread({
        forwardedRef: ref
    }, props));
})));
var CardContentFHardcoded_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "ex580fn0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        // paddingBottom: `${theme.spacing(3)} !important`,
        width: "100%",
        justifyContent: "space-between"
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        padding: theme.spacing(3, 2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var CardContentFHardcoded_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentFHardcoded_Typography, {
    target: "ex580fn1"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        display: "inline-block",
        paddingBottom: theme.spacing(1),
        fontSize: theme.spacing(2.5),
        fontWeight: "bold",
        color: theme.theme_component_navigation_bar_background_color,
        whiteSpace: "inherit"
    }, theme.breakpoints.down("sm"), {
        fontSize: theme.spacing(2.25),
        lineHeight: theme.spacing(2.75)
    });
});
var CardContentFHardcoded_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentFHardcoded_Typography, {
    target: "ex580fn2"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: "auto",
        fontSize: theme.spacing(2),
        color: "#6E6E6E",
        lineHeight: "28px"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        minHeight: "80px",
        fontSize: theme.spacing(1.75),
        lineHeight: theme.spacing(2.5)
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        height: "80px"
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), (0,src_define_property/* default */.Z)({}, theme.breakpoints.down("lg"), {
        height: "70px",
        lineHeight: "20px"
    })), _obj;
});
var LinkContainer = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(Link, {
    target: "ex580fn3"
})(function(param) {
    var theme = param.theme;
    return _define_property({
        color: theme.theme_component_navigation_bar_background_color || "#0C0C0C",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        fontWeight: 500,
        textAlign: "center",
        textDecoration: "none"
    }, theme.breakpoints.down("sm"), {
        fontSize: "14px",
        lineHeight: "18px",
        textAlign: "left",
        justifyContent: "flex-start"
    });
})));
var CardContentFHardcoded_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CardContentFHardcoded = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className;
    var t = (0,esm/* useTranslation */.$G)("card_content_f").t;
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentFHardcoded_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentFHardcoded_CardTitle, {
                variant: "caption",
                component: "span",
                noWrap: true,
                children: CardContentFHardcoded_getText(title || "", limit || 35)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentFHardcoded_Description, {
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary",
                children: description && CardContentFHardcoded_getText(description, limit || 130)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentG.tsx











var CardContentG_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentG_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentG_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1oxayk30"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        width: "300px",
        minWidth: "300px",
        display: "flex",
        flexDirection: "column",
        height: "80%",
        padding: theme.spacing(4)
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("lg"), {
        padding: theme.spacing(2)
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        padding: theme.spacing(1),
        height: "90%",
        width: "100%",
        minWidth: "unset"
    }), _obj;
});
var ContentSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1oxayk31"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "flex-start",
        backgroundColor: theme.palette.background.paper,
        height: "100%"
    };
});
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentG_Typography, {
    target: "e1oxayk32"
})(function(param) {
    var theme = param.theme;
    return {
        fontSize: theme.spacing(3),
        fontWeight: "bold",
        color: theme.palette.text.primary
    };
});
var DeveloperName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentG_Typography, {
    target: "e1oxayk33"
})(function(param) {
    var theme = param.theme;
    return {
        height: "auto",
        fontSize: theme.typography.h3.fontSize,
        fontWeight: theme.typography.h3.fontWeight,
        color: theme.palette.text.secondary
    };
});
var CardContentG_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentG_Typography, {
    target: "e1oxayk34"
})(function(param) {
    var theme = param.theme;
    return {
        fontSize: theme.spacing(2),
        marginBottom: theme.spacing(3),
        color: theme.palette.text.secondary
    };
});
var PlayButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentG_Button, {
    target: "e1oxayk35"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        width: "100%",
        padding: theme.spacing(1, 3),
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main,
        borderRadius: theme.theme_component_feature_grid_a_card_button_border_radius ? "".concat(theme.theme_component_feature_grid_a_card_button_border_radius, "px") : "16px",
        fontSize: theme.theme_component_feature_grid_a_card_button_font_size ? "".concat(theme.theme_component_feature_grid_a_card_button_font_size, "px") : "16px",
        fontWeight: theme.theme_component_feature_grid_a_card_button_font_weight || "normal",
        border: "1px solid #ebebeb"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        width: "fit-content"
    }), (0,src_define_property/* default */.Z)(_obj, "&:hover", {
        backgroundColor: theme.palette.primary.dark
    }), _obj;
});
var CardContentG = function(props) {
    var description = props.description, _hideDescription = props.hideDescription, hideDescription = _hideDescription === void 0 ? true : _hideDescription, title = props.title, limit = props.limit, className = props.className, children = props.children, company = props.company, hideDeveloperName = props.hideDeveloperName;
    var t = (0,esm/* useTranslation */.$G)("card_content_g").t;
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentG_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentSection, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        variant: "h5",
                        component: "h3",
                        children: getText(title || "", limit || 35)
                    }),
                    !hideDeveloperName && company && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeveloperName, {
                        variant: "body1",
                        component: "p",
                        children: company && getText(company, limit || 35)
                    }),
                    !hideDescription && description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentG_Description, {
                        variant: "body1",
                        component: "p",
                        children: description && getText(description, limit || 100)
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayButton, {
                variant: "contained",
                children: componentOptions.component_card_title_text || t("play_now", "Play")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentH.tsx










var CardContentH_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentH_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// Play button overlay that goes on top of the image
var PlayButtonContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efnx5ij0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        position: "absolute",
        top: -12,
        left: "50%",
        transform: "translateX(-50%)",
        right: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2,
        pointerEvents: "none",
        maxWidth: 61
    }, theme.breakpoints.between("cmd", "clg"), {
        top: -8
    });
});
var CardContentH_PlayButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentH_Button, {
    target: "efnx5ij1"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        minWidth: "110px",
        whiteSpace: "nowrap",
        padding: "4px 24px",
        height: "26px",
        fontSize: "18px",
        textTransform: "none",
        fontWeight: theme.typography.h1.fontWeight || 700,
        borderRadius: theme.theme_component_carousel_c18_card_button_border_radius || theme.spacing(1),
        pointerEvents: "auto",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
        background: theme.theme_component_carousel_c18_card_button_background || theme.palette.primary.main,
        color: theme.theme_component_carousel_c18_card_button_color || theme.palette.primary.contrastText,
        "&:hover": {
            background: theme.theme_component_carousel_c18_card_button_hover_background_color,
            color: theme.theme_component_carousel_c18_card_button_active_background_color
        }
    }, theme.breakpoints.between("cmd", "clg"), {
        fontSize: "6.37px",
        width: "61px",
        height: "13.79px",
        minWidth: "auto"
    });
});
// Content container (title and description)
var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "efnx5ij2"
})(function(param) {
    var theme = param.theme, hoverActive = param.hoverActive;
    return (0,src_define_property/* default */.Z)({
        display: "flex",
        flex: 1,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        position: "relative",
        backgroundColor: theme.theme_component_card_background_color || "#FFFFFF",
        borderRadius: "0 0 8px 8px",
        "&:hover": hoverActive && {
            backgroundColor: theme.theme_component_card_hover_background_color || "#FFFFFF"
        }
    }, theme.breakpoints.between("cmd", "clg"), {
        padding: "0 !important"
    });
});
var TitleText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentH_Typography, {
    target: "efnx5ij3"
})(function(param) {
    var theme = param.theme, hideDescription = param.hideDescription;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        fontWeight: theme.typography.h1.fontWeight || 700,
        marginTop: hideDescription ? theme.spacing(3) : theme.spacing(1),
        fontSize: "18px",
        lineHeight: "normal",
        textAlign: "center",
        color: theme.theme_component_title_color || "#000000",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical"
    }, theme.breakpoints.between("cmd", "clg"), {
        fontSize: "10px",
        lineHeight: "9.39px",
        margin: "15px 0"
    });
});
var DescriptionText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentH_Typography, {
    target: "efnx5ij4"
})(function(param) {
    var theme = param.theme, hideGameTitle = param.hideGameTitle;
    return {
        width: "100%",
        marginTop: hideGameTitle ? theme.spacing(2) : theme.spacing(1),
        fontWeight: 400,
        fontSize: hideGameTitle ? "14px" : "12px",
        lineHeight: hideGameTitle ? "18px" : "14px",
        textAlign: "center",
        color: theme.theme_component_game_description_font_color || "#666666",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        minHeight: "14px"
    };
});
var PlaceholderText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efnx5ij5"
})(function() {
    return {
        width: "80%",
        height: "100%",
        backgroundColor: "transparent",
        opacity: 0
    };
});
var CardContentH = function(props) {
    var title = props.title, description = props.description, _hideGameTitle = props.hideGameTitle, hideGameTitle = _hideGameTitle === void 0 ? false : _hideGameTitle, _hideDescription = props.hideDescription, hideDescription = _hideDescription === void 0 ? false : _hideDescription, _hidePlayButton = props.hidePlayButton, hidePlayButton = _hidePlayButton === void 0 ? false : _hidePlayButton, _hoverActive = props.hoverActive, hoverActive = _hoverActive === void 0 ? true : _hoverActive, limit = props.limit, className = props.className;
    var t = (0,esm/* useTranslation */.$G)("card_content_f").t;
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            className: className,
            hoverActive: hoverActive,
            children: [
                !hidePlayButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayButtonContainer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentH_PlayButton, {
                        variant: "contained",
                        disableElevation: true,
                        size: "small",
                        children: componentOptions.component_card_title_text || t("play_now", "Play")
                    })
                }),
                !hideGameTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleText, {
                    variant: "body1",
                    hideDescription: hideDescription,
                    children: title ? getText(title, limit || 35) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlaceholderText, {
                        style: {
                            height: "14px"
                        }
                    })
                }),
                !hideDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionText, {
                    variant: "body2",
                    hideGameTitle: hideGameTitle,
                    children: description ? getText(description, limit || 60) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlaceholderText, {
                        style: {
                            height: "10px"
                        }
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
;// CONCATENATED MODULE: ./src/components/CustomButton/index.tsx







var CustomButton_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "e12zvydl0"
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.primary.contrastText,
        background: theme.palette.primary.main,
        borderRadius: "".concat(theme.theme_component_feature_grid_a_card_button_border_radius, "px"),
        fontSize: theme.theme_component_feature_grid_a_card_button_font_size || "16px",
        fontWeight: theme.theme_component_feature_grid_a_card_button_font_weight,
        padding: "6px 16px"
    };
});
var CustomButton = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomButton_ButtonStyled, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/Card/CollectionContentA.tsx












var CollectionContentA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CollectionContentA_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1rr55dw0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        paddingBottom: "".concat(theme.spacing(1), " !important"),
        justifyContent: "center",
        maxHeight: 85
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        padding: theme.spacing(1, 1.5),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var CollectionContentA_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentA_Typography, {
    target: "e1rr55dw1"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        display: "inline-block",
        color: "#000"
    };
});
var CardContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z, {
    target: "e1rr55dw2"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        width: "100%",
        "& span": {
            flex: 1,
            marginRight: theme.spacing(1)
        }
    };
});
var CollectionContentA_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentA_Typography, {
    target: "e1rr55dw3"
})(function(param) {
    var theme = param.theme;
    return {
        height: "auto",
        minHeight: "45px",
        display: "-webkit-box",
        "-webkit-line-clamp": "2",
        overflow: "hidden",
        "text-overflow": "ellipsis",
        "-webkit-box-orient": "vertical"
    };
});
var CollectionContentA_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CustomButton, {
    target: "e1rr55dw4"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        display: "flex",
        margin: 0,
        pointerEvents: "auto",
        alignSelf: "center",
        padding: theme.spacing(0.4, 4.5),
        borderRadius: theme.theme_component_carousel_a_card_button_border_radius || theme.spacing(9),
        background: theme.theme_component_carousel_a_card_button_background || theme.palette.primary.main,
        color: theme.theme_component_carousel_a_card_button_color || theme.palette.primary.contrastText,
        "&:hover": {
            background: theme.theme_component_carousel_a_card_button_hover_background_color,
            color: theme.theme_component_carousel_a_card_button_active_background_color
        }
    }, theme.breakpoints.down(1300), {
        padding: "0px 4px"
    });
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CollectionContentA = function(props) {
    var description = props.description, hidePlayButton = props.hidePlayButton, title = props.title, limit = props.limit, className = props.className, hideDescription = props.hideDescription;
    var body2Ref = react.useRef(null);
    var t = (0,esm/* useTranslation */.$G)("card_content_c").t;
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentA_CardContentStyled, {
        className: className,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentA_CardTitle, {
                    variant: "caption",
                    noWrap: true,
                    children: getText(title || "", limit || 35)
                }),
                !hideDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentA_Description, {
                    ref: body2Ref,
                    variant: "body2",
                    color: "textPrimary",
                    children: description && getText(description, limit || 75)
                }),
                !hidePlayButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentA_ButtonStyled, {
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    className: "card-content-button",
                    children: componentOptions.component_card_title_text || t("play_now", "Play")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CollectionContentB.tsx



// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CollectionContentB = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "title",
        "limit",
        "className"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
};

;// CONCATENATED MODULE: ./src/components/Card/CollectionContentC.tsx












var CollectionContentC_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CollectionContentC_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "erfbzur0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        position: "relative",
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "left",
        padding: theme.spacing(2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none",
        flex: 1,
        minHeight: 132
    };
});
var CardContentInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erfbzur1"
})(function(param) {
    var theme = param.theme;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "center"
    };
});
var CollectionContentC_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentC_Typography, {
    target: "erfbzur2"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        display: "inline-block",
        color: "#000",
        marginRight: theme.spacing(1.5)
    };
});
var CollectionContentC_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentC_Typography, {
    target: "erfbzur3"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: "auto",
        fontWeight: theme.typography.h3.fontWeight,
        // @ts-ignore
        fontSize: "".concat(theme.typography.h1.fontSize.split("rem")[0] * 0.9167, "rem")
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("cxxl"), {
        // @ts-ignore
        fontSize: "".concat(theme.typography.h1.fontSize.split("rem")[0] * 0.625333, "rem")
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("cxl"), {
        // @ts-ignore
        fontSize: "".concat(theme.typography.h1.fontSize.split("rem")[0] * 0.583333, "rem")
    }), _obj;
});
var CollectionContentC_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CustomButton, {
    target: "erfbzur4"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        margin: 0,
        pointerEvents: "auto",
        alignSelf: "center",
        padding: theme.spacing(1.5, 6.75),
        background: theme.theme_component_feature_grid_a_card_button_background || theme.palette.primary.main,
        color: theme.theme_component_feature_grid_a_card_button_color || theme.palette.primary.contrastText,
        borderRadius: theme.theme_component_feature_grid_a_card_button_border_radius || theme.spacing(9),
        "&:hover": {
            background: theme.theme_component_feature_grid_a_card_button_background,
            color: theme.theme_component_feature_grid_a_card_button_active_background_color
        }
    };
});
var CollectionContentC = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, company = props.company, _hideDeveloperName = props.hideDeveloperName, hideDeveloperName = _hideDeveloperName === void 0 ? false : _hideDeveloperName, hidePlayButton = props.hidePlayButton, hideInfoSection = props.hideInfoSection, _hideDescription = props.hideDescription, hideDescription = _hideDescription === void 0 ? true : _hideDescription, hideTitle = props.hideTitle;
    var t = (0,esm/* useTranslation */.$G)("card_content_c").t;
    var buttonRef = react.useRef(null);
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (title || description || company) && !hideInfoSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentC_CardContentStyled, {
            className: "card-content",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentInfo, {
                    className: "card-content-info",
                    children: [
                        !hideTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentC_CardTitle, {
                            variant: "caption",
                            noWrap: true,
                            children: getText(title || "", limit || 35)
                        }),
                        !hideDeveloperName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentC_Description, {
                            variant: "body2",
                            color: "textPrimary",
                            children: company && getText(company, limit || 35)
                        }),
                        !hideDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentC_Description, {
                            variant: "body2",
                            color: "textPrimary",
                            children: description && getText(description, limit || 80)
                        })
                    ]
                }),
                !hidePlayButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentC_ButtonStyled, {
                    ref: buttonRef,
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    className: "card-content-button",
                    children: componentOptions.component_card_title_text || t("play_now", "Play")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CollectionContentD.tsx











var CollectionContentD_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CollectionContentD_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1ucxwpv0"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        width: "100%"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        textAlign: "left",
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none",
        padding: 0,
        paddingBottom: "0 !important",
        paddingLeft: theme.spacing(1.5)
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("csm"), {
        display: "flex",
        width: "100%",
        paddingTop: "0px"
    }), _obj;
});
var CollectionContentD_CardContentInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ucxwpv1"
})(function(param) {
    var theme = param.theme;
    return {
        flexDirection: "column",
        flex: 1,
        "-webkit-line-clamp": "1",
        overflow: "hidden",
        "text-overflow": "ellipsis",
        "-webkit-box-orient": "vertical",
        display: "-webkit-box"
    };
});
var CollectionContentD_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentD_Typography, {
    target: "e1ucxwpv2"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        width: "100%",
        display: "inline-block",
        color: "#000"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("csm"), {
        fontSize: "24px"
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("csm"), {
        fontSize: "15px"
    }), _obj;
});
var CollectionContentD_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentD_Typography, {
    target: "e1ucxwpv3"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        height: "auto",
        display: "-webkit-box",
        "-webkit-line-clamp": "2",
        overflow: "hidden",
        "text-overflow": "ellipsis",
        "-webkit-box-orient": "vertical"
    }, theme.breakpoints.down("csm"), {
        fontSize: "12px"
    });
});
var CollectionContentD_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CustomButton, {
    target: "e1ucxwpv4"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: 0,
        pointerEvents: "auto",
        alignSelf: "center",
        borderRadius: "46px",
        width: "107px",
        height: "40px",
        fontSize: "20px"
    }, theme.breakpoints.down("cxs"), {
        width: "85px",
        height: "31px",
        fontSize: "16px"
    });
});
var CollectionContentD_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
var CollectionContentD = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, company = props.company, hideInfoSection = props.hideInfoSection, _hideDeveloperName = props.hideDeveloperName, hideDeveloperName = _hideDeveloperName === void 0 ? false : _hideDeveloperName, _hideDescription = props.hideDescription, hideDescription = _hideDescription === void 0 ? true : _hideDescription, hidePlayButton = props.hidePlayButton;
    var t = (0,esm/* useTranslation */.$G)("card_content_e").t;
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (title || description || company) && !hideInfoSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentD_CardContentStyled, {
            className: className,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentD_CardContentInfo, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentD_CardTitle, {
                            variant: "caption",
                            noWrap: true,
                            children: CollectionContentD_getText(title || "", limit || 35)
                        }),
                        !hideDeveloperName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentD_Description, {
                            variant: "body2",
                            color: "textPrimary",
                            children: company && CollectionContentD_getText(company, limit || 80)
                        }),
                        !hideDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentD_Description, {
                            variant: "body2",
                            color: "textPrimary",
                            children: description && CollectionContentD_getText(description, limit || 80)
                        })
                    ]
                }),
                !hidePlayButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentD_ButtonStyled, {
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    children: componentOptions.component_card_title_text || t("play_now", "Play")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CollectionContentE.tsx












var CollectionContentE_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CollectionContentE_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1dxwv9c0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        position: "relative",
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "left",
        padding: theme.spacing(2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none",
        flex: 1
    };
});
var CollectionContentE_CardContentInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1dxwv9c1"
})(function(param) {
    var theme = param.theme;
    return {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    };
});
var CollectionContentE_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentE_Typography, {
    target: "e1dxwv9c2"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        display: "inline-block",
        color: "#000"
    }, theme.breakpoints.between("cmd", "clg"), {
        fontSize: "9px",
        lineHeight: "40px"
    });
});
var CollectionContentE_DeveloperName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentE_Typography, {
    target: "e1dxwv9c3"
})(function(param) {
    var theme = param.theme;
    return {
        height: "auto"
    };
});
var CollectionContentE_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CustomButton, {
    target: "e1dxwv9c4"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        margin: 0,
        pointerEvents: "auto",
        alignSelf: "center",
        borderRadius: theme.theme_component_carousel_b_card_button_border_radius || "46px",
        background: theme.theme_component_carousel_c_card_button_background || theme.palette.primary.main,
        color: theme.theme_component_carousel_c_card_button_color || theme.palette.primary.contrastText,
        "&:hover": {
            background: theme.theme_component_carousel_c_card_button_hover_background_color,
            color: theme.theme_component_carousel_c_card_button_active_background_color
        }
    };
});
var CollectionContentE = function(props) {
    var hideTitle = props.hideTitle, title = props.title, hideDeveloperName = props.hideDeveloperName, company = props.company, limit = props.limit, className = props.className, hidePlayButton = props.hidePlayButton;
    var t = (0,esm/* useTranslation */.$G)("card_content_e").t;
    var buttonRef = react.useRef(null);
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (title || company) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentE_CardContentStyled, {
            className: className,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentE_CardContentInfo, {
                    children: [
                        !hideTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentE_CardTitle, {
                            variant: "h3",
                            noWrap: true,
                            children: getText(title || "", limit || 30)
                        }),
                        !hideDeveloperName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentE_DeveloperName, {
                            variant: "body2",
                            color: "textPrimary",
                            children: company && getText(company, limit || 35)
                        })
                    ]
                }),
                !hidePlayButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentE_ButtonStyled, {
                    ref: buttonRef,
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    children: componentOptions.component_card_title_text || t("play_now", "Play")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CollectionContentF.tsx












var CollectionContentF_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CollectionContentF_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "ehczmie0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        position: "relative",
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "left",
        padding: theme.spacing(2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none",
        flex: 1,
        minHeight: 105
    }, theme.breakpoints.between("clg", "cxl"), {
        minHeight: 73
    });
});
var CollectionContentF_CardContentInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehczmie1"
})(function(param) {
    var theme = param.theme;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "center"
    };
});
var CollectionContentF_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentF_Typography, {
    target: "ehczmie2"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        display: "inline-block",
        color: "#000",
        marginRight: theme.spacing(1.5),
        fontSize: "22px"
    }, theme.breakpoints.between("clg", "cxl"), {
        fontSize: "15px"
    });
});
var CollectionContentF_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentF_Typography, {
    target: "ehczmie3"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        height: "auto",
        fontSize: "22px",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }, theme.breakpoints.between("clg", "cxl"), {
        fontSize: "15px",
        WebkitLineClamp: 1
    });
});
var CollectionContentF_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CustomButton, {
    target: "ehczmie4"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        margin: 0,
        pointerEvents: "auto",
        alignSelf: "center",
        padding: theme.spacing(1.5, 6.75),
        marginLeft: 8,
        background: theme.theme_component_feature_grid_a_card_button_background || theme.palette.primary.main,
        color: theme.theme_component_feature_grid_a_card_button_color || theme.palette.primary.contrastText,
        borderRadius: theme.theme_component_feature_grid_b_card_button_border_radius || theme.spacing(9),
        "&:hover": {
            background: theme.theme_component_feature_grid_a_card_button_background || theme.palette.primary.main,
            color: theme.theme_component_feature_grid_b_card_button_active_background_color || theme.palette.primary.main
        }
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("cxl"), {
        minWidth: 155,
        minHeight: 53
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.between("clg", "cxl"), {
        width: 108,
        height: 37,
        fontSize: 14
    }), _obj;
});
var CollectionContentF = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, company = props.company, _hideDeveloperName = props.hideDeveloperName, hideDeveloperName = _hideDeveloperName === void 0 ? false : _hideDeveloperName, hidePlayButton = props.hidePlayButton, hideInfoSection = props.hideInfoSection, _hideDescription = props.hideDescription, hideDescription = _hideDescription === void 0 ? true : _hideDescription, hideTitle = props.hideTitle;
    var t = (0,esm/* useTranslation */.$G)("card_content_c").t;
    var buttonRef = react.useRef(null);
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (title || description || company) && !hideInfoSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentF_CardContentStyled, {
            className: "card-content",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentF_CardContentInfo, {
                    className: "card-content-info",
                    children: [
                        !hideTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentF_CardTitle, {
                            variant: "caption",
                            noWrap: true,
                            children: getText(title || "", limit || 35)
                        }),
                        !hideDeveloperName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentF_Description, {
                            variant: "body2",
                            color: "textPrimary",
                            children: company && getText(company, limit || 35)
                        }),
                        !hideDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentF_Description, {
                            variant: "body2",
                            color: "textPrimary",
                            children: description && getText(description, limit || 80)
                        })
                    ]
                }),
                !hidePlayButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentF_ButtonStyled, {
                    ref: buttonRef,
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    className: "card-content-button",
                    children: componentOptions.component_card_title_text || t("play_now", "Play")
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Card/CollectionContentG.tsx












var CollectionContentG_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CollectionContentG_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1ak3p7b0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        position: "relative",
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "left",
        padding: theme.spacing(2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none",
        flex: 1
    };
});
var CollectionContentG_CardContentInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ak3p7b1"
})(function(param) {
    var theme = param.theme;
    return {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    };
});
var CollectionContentG_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentG_Typography, {
    target: "e1ak3p7b2"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        display: "inline-block",
        color: "#000"
    }, theme.breakpoints.between("cmd", "clg"), {
        fontSize: "9px",
        lineHeight: "40px"
    });
});
var CollectionContentG_DeveloperName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentG_Typography, {
    target: "e1ak3p7b3"
})(function(param) {
    var theme = param.theme;
    return {
        height: "auto"
    };
});
var CollectionContentG_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CustomButton, {
    target: "e1ak3p7b4"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        margin: 0,
        pointerEvents: "auto",
        alignSelf: "center",
        borderRadius: theme.theme_component_carousel_d_card_button_border_radius || "46px",
        background: theme.theme_component_carousel_d_card_button_background || theme.palette.primary.main,
        color: theme.theme_component_carousel_d_card_button_color || theme.palette.primary.contrastText,
        "&:hover": {
            background: theme.theme_component_carousel_d_card_button_hover_background_color,
            color: theme.theme_component_carousel_d_card_button_active_background_color
        }
    };
});
var CollectionContentG = function(props) {
    var hideTitle = props.hideTitle, title = props.title, hideDeveloperName = props.hideDeveloperName, company = props.company, limit = props.limit, className = props.className, hidePlayButton = props.hidePlayButton;
    var t = (0,esm/* useTranslation */.$G)("card_content_e").t;
    var buttonRef = react.useRef(null);
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (title || company) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentG_CardContentStyled, {
            className: className,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentG_CardContentInfo, {
                    children: [
                        !hideTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentG_CardTitle, {
                            variant: "h3",
                            noWrap: true,
                            children: getText(title || "", limit || 30)
                        }),
                        !hideDeveloperName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentG_DeveloperName, {
                            variant: "body2",
                            color: "textPrimary",
                            children: company && getText(company, limit || 35)
                        })
                    ]
                }),
                !hidePlayButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentG_ButtonStyled, {
                    ref: buttonRef,
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    children: componentOptions.component_card_title_text || t("play_now", "Play")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/Card.tsx






























var CardStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* default */.Z, {
    target: "ejnpo760"
})(function(param) {
    var theme = param.theme, template = param.template, hoverEffect = param.hoverEffect, cardBorder = param.cardBorder;
    return {};
});
var Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejnpo761"
})(function(param) {
    var theme = param.theme, _innerFlex = param.innerFlex, innerFlex = _innerFlex === void 0 ? "column" : _innerFlex, _innerAlign = param.innerAlign, innerAlign = _innerAlign === void 0 ? "normal" : _innerAlign;
    return (0,src_define_property/* default */.Z)({
        display: "flex",
        height: "100%",
        flexDirection: innerFlex,
        alignItems: innerAlign
    }, theme.breakpoints.down("md"), {
        flexDirection: "column"
    });
});
var templateComponents = {
    default: CardContentA,
    simple: CardContentB,
    extensive: CardContentC,
    big: react.Fragment,
    cnn: CardContentF,
    banner: CardContentBanner,
    cnnactivities: CardContentFHardcoded,
    partial: CardContentE,
    CarouselA: CollectionContentA,
    CarouselB: CollectionContentB,
    CarouselC: CollectionContentE,
    CarouselD: CollectionContentG,
    SliderListC13Slick: CollectionContentC,
    FeatureGridA: CollectionContentC,
    FeatureGridB: CollectionContentF,
    ListViewA: CollectionContentD,
    BannerHorizontalA: CardContentG,
    C18: CardContentH
};
var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var basePath = publicRuntimeConfig.basePath || "";
var Card_Card = function(props) {
    var _href = props.href, href = _href === void 0 ? "/" : _href, src = props.src, width = props.width, height = props.height, alt = props.alt, _template = props.template, template = _template === void 0 ? "default" : _template, title = props.title, company = props.company, description = props.description, className = props.className, sx = props.sx, typographyOptions = props.typographyOptions, hoverEffect = props.hoverEffect, innerFlex = props.innerFlex, innerFlexSize = props.innerFlexSize, cardBorder = props.cardBorder, configuration = props.configuration, configurationStyle = props.configurationStyle, hideDescription = props.hideDescription, hideTitle = props.hideTitle, hideGameTitle = props.hideGameTitle, hideDeveloperName = props.hideDeveloperName, hidePlayButton = props.hidePlayButton, hideInfoSection = props.hideInfoSection, assetsx = props.assetsx, collection = props.collection, _targetBlank = props.targetBlank, targetBlank = _targetBlank === void 0 ? false : _targetBlank, other = (0,_object_without_properties/* default */.Z)(props, [
        "href",
        "src",
        "width",
        "height",
        "alt",
        "template",
        "title",
        "company",
        "description",
        "className",
        "sx",
        "typographyOptions",
        "hoverEffect",
        "innerFlex",
        "innerFlexSize",
        "cardBorder",
        "configuration",
        "configurationStyle",
        "hideDescription",
        "hideTitle",
        "hideGameTitle",
        "hideDeveloperName",
        "hidePlayButton",
        "hideInfoSection",
        "assetsx",
        "collection",
        "targetBlank"
    ]);
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var onGameCardClick = appContext.useCollectionCrumbs().onGameCardClick;
    var cardWidth = width || componentOptions.component_card_width || 100;
    var cardHeight = height || componentOptions.component_card_height || 100;
    var ContentComponent = templateComponents[template] || CardContentA;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardStyled, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        elevation: 0,
        className: className,
        sx: sx,
        hoverEffect: hoverEffect,
        template: template,
        cardBorder: cardBorder
    }, useEditorHandlers("Card", configuration, configurationStyle)), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardActionArea/* default */.Z, {
            component: components_Link/* Link */.r,
            onClick: function() {
                return onGameCardClick({
                    name: (collection === null || collection === void 0 ? void 0 : collection.name) || "",
                    slug: (collection === null || collection === void 0 ? void 0 : collection.slug) || ""
                });
            },
            href: typeof href === "string" ? href.includes("http") ? href : "/game/".concat(href) : href,
            target: targetBlank ? "_blank" : undefined,
            rel: targetBlank ? "noopener noreferrer" : undefined,
            sx: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
                className: "inner-card",
                innerFlexSize: innerFlexSize,
                innerFlex: innerFlex,
                style: {
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardAsset, (0,src_object_spread/* default */.Z)({
                        innerFlexSize: innerFlexSize,
                        src: "".concat(basePath).concat(src),
                        width: cardWidth,
                        height: cardHeight,
                        alt: alt,
                        assetsx: assetsx
                    }, other)),
                    template === "partial" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentComponent, (0,src_object_spread/* default */.Z)({
                        width: width,
                        height: height
                    }, other)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentComponent, (0,src_object_spread/* default */.Z)({
                        title: title,
                        description: description,
                        hideDescription: hideDescription,
                        hideTitle: hideTitle,
                        hideGameTitle: hideGameTitle,
                        hideDeveloperName: hideDeveloperName,
                        hidePlayButton: hidePlayButton,
                        hideInfoSection: hideInfoSection,
                        company: company
                    }, typographyOptions, other))
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
;// CONCATENATED MODULE: ./src/components/Card/CardSkeleton.tsx




var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e17ommov0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        height: "100%",
        borderRadius: theme.theme_component_card_border_radius || theme.shape.borderRadius,
        backgroundColor: theme.theme_component_card_background_color || theme.palette.background.paper
    };
});
var CardSkeleton = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, (0,src_object_spread/* default */.Z)({}, props));
};

;// CONCATENATED MODULE: ./src/components/Card/index.ts












/***/ })

}]);